import styled from 'styled-components';

import { Availability } from '@utils/getAvailability';

const Wrapper = styled.div`
  margin-bottom: 1rem;
  @media ${(props) => props.theme.breakpoints.lg} {
    text-align: center;
  }
`;

const UnorderedList = styled.ul`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  list-style-position: inside;
  margin: 0 auto;
  padding: 0;

  @media ${(props) => props.theme.breakpoints.lg} {
    display: inline-block;
  }

  &:after {
    content: '';
    display: block;
    clear: both;
  }
`;

const ListItem = styled.li<{ section: string }>`
  float: left;
  margin-left: 10px;
  padding-left: 0;
  text-transform: capitalize;

  &::marker {
    color: ${(props) =>
      props.theme.colors ? props.theme.colors[props.section] : '#000000'};
  }

  &:first-child {
    list-style-type: none;
    margin-left: 0;
  }

  &:nth-child(4) {
    list-style-type: none;
    text-align: center;
    width: 100%;
  }

  @media ${(props) => props.theme.breakpoints.lg} {
    width: auto;

    &:nth-child(4) {
      list-style-type: unset;
      text-align: unset;
      width: auto;
    }
  }
`;

export interface ProductMetaProps {
  figures?: string;
  figuresName?: string;
  isResponsive?: boolean;
  parts?: string;
  partsName?: string;
  reference?: string;
  referenceName?: string;
  releaseStatus: Availability;
  section: Section;
}

const ProductInfoMeta = ({
  figures,
  figuresName,
  parts,
  partsName,
  reference,
  referenceName,
  releaseStatus,
  section,
}: ProductMetaProps) => {
  return (
    <Wrapper>
      <UnorderedList>
        <ListItem section={section.toLowerCase()}>
          <strong>{referenceName}</strong>: {reference}
        </ListItem>
        <ListItem section={section.toLowerCase()}>
          <strong>{partsName}</strong>:{' '}
          {parts
            ? new Intl.NumberFormat().format(parseFloat(parts))
            : 'Unknown'}
        </ListItem>
        <ListItem section={section.toLowerCase()}>
          <strong>{figuresName}</strong>: {figures}
        </ListItem>
        <ListItem section={section.toLowerCase()}>
          <strong>Availability</strong>:{' '}
          {releaseStatus.text || releaseStatus.status}
        </ListItem>
      </UnorderedList>
    </Wrapper>
  );
};

export default ProductInfoMeta;
